// components/Header/Header.tsx
"use client";
import {
  Flex,
  Text,
  Image,
  Box,
  Button,
  useDisclosure,
  Heading,
  Show,
} from "@chakra-ui/react";
import hero from "@public/hero.png";
import background_image from "@public/pexels-francesco-ungaro-998641-2.webp";
import "./Header.css";
import { GoogleForm, Navbar } from "..";
import { FaDiscord } from "react-icons/fa";
import gallery from "@public/Screenshot 2024-05-22 at 13.44 2 (2).png"
import mobilegallery from "@public/Screenshot 2024-05-22 at 13.44 2 (1).png"
import { Metadata } from 'next';

export const generateMetadata = (): Metadata => ({
  title: { absolute: "DeepMode | AI Character Creation & Art Generator" },
  description: "Create unique AI-generated art with DeepMode. Our advanced AI models let you design custom characters and produce stunning digital images. Explore the future of AI-powered creativity today.",
});

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {/* Mobile, < 768px */}
      <Show below="md-1">
        <Flex bg="#050918" direction="column">
          <Flex
            direction="column"
            textAlign="center"
            align="center"
            pt="30px"
            backgroundImage={background_image.src}
            backgroundSize="contain"
            opacity="1"
            mixBlendMode="lighten"
          >
            <Flex align="center">
              <Flex align="center" direction="column">
              <Text
  textAlign="center"
  fontSize="38px"
  fontWeight="bold"
  color="white"
  lineHeight={0.9}
  as={"h1"}
>
  <span>Your AI </span>
  <span
    style={{ marginTop: "-20px" }}
  >
    character
  </span>
  <br/>
  <span
    style={{
      background: "linear-gradient(to right, #FFE1FF 10%, #A4DBEE 40%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontWeight: "extrabold",
      marginTop: "-20px",
    }}
  >
    Reimagined.
  </span>
</Text>
                <Heading
                  as={"h1"}
                  textAlign="center"
                  maxW="300px"
                  fontSize="13px"
                  color="white"
                  mt="15px"
                >
                  Create your own AI Clone with unlimited creativity. 
                  Generate perfect AI images every time.
                </Heading>
                <GoogleForm isOpen={isOpen} onClose={onClose} />
                <Flex direction={{base:"column", md:"row"}} mt="20px" align="center">
                  <Button
                    p="18px"
                    h="58px"
                    onClick={onOpen}
                    maxW={{base:"100%", md:"180px"}}
                    minW={{base:"100%", md:"180px"}}
                    color="white"
                    bg="button.500"
                    _hover={{opacity:"0.9"}}

                  >
                    Start creating for free
                  </Button>
                  <a href="https://discord.gg/CMwtccKthy" target="_blank">
                    <Button
                    mt={{base:"15px", md:0}}
                      ml={{base:0, md:"5px"}}
                      borderRadius="12px"
                      p="18px"
                      h="58px"
                      maxW={{base:"209px", md:"180px"}}
                      minW={{base:"209px", md:"180px"}}
                      leftIcon={<FaDiscord size="28px" />}
                      color="#5865F2"
                      variant="outline"
                      borderColor="#5865F2"
                      borderWidth="2px"
                    >
                      Join Discord
                    </Button>
                  </a>
                </Flex>
              </Flex>
            </Flex>
            <Flex>
              <Image
                mt="30px"
                w="100%"
                src={mobilegallery.src}
                alt="AI generated gallery"              />
            </Flex>
          </Flex>
          <Flex
            color="white"
            px={["25px", "35px", "40px", "60px", "60px", "22%"]}
            py="26px"
            overflow="hidden"
            justify="start"
            fontWeight="semibold"
            position="relative"
            w="100%"
            bg="black"
          >
            <div className="scrolling-text">
              <Text>
                ✨ Every photo is unique! ✨ Endless generations! ✨ Endless
                Variations ✨ Unimaginable scenes
              </Text>
            </div>
          </Flex>
        </Flex>
      </Show>
      {/* Desktop, >= 768px */}
      <Show above="md">
        <Flex direction="column">
          <Flex
            opacity={0.9}
            h="100%"
            direction="column"
            backgroundRepeat="no-repeat"
            bg="#050918"
            position="relative"
          >
            <Box
              position="absolute"
              top="0"
              left="0"
              width="100%"
              height="60%"
              backgroundImage={background_image.src}
              backgroundSize="contain"
              opacity="1"
              mixBlendMode="lighten"
              zIndex="0"
            />
            <Navbar />
            <Flex
              px={["25px", "35px", "40px", "60px", "60px", "15%"]}
              justify="center"
              align="center"
              mt="30px"
            >
              <Flex
                minW={{ base: "300px", md: "390px", lg: "400px", xl: "550px" }}
                direction="column"
                justify="center"
                align="center"
                h="100%"
              >
 <Text
  textAlign="center"
  fontSize="3.75rem"
  fontWeight="bold"
  color="white"
  as={"h1"}
  lineHeight={1.2}
>
  <span >
    Your AI Character
  </span>
  <br/>
  <span
    style={{
      background: "linear-gradient(to right, #FFE1FF 10%, #A4DBEE 40%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      fontWeight: "extrabold",
    }}
  >
    Reimagined.
  </span>
</Text>

                <GoogleForm isOpen={isOpen} onClose={onClose} />
                <Text
                  maxW={{ base: "300px", md: "370px", "2xl": "600px" }}
                  color="white"
                  fontWeight={500}
                  fontSize={{
                    sm: "14px",
                    md: "16px",
                    lg: "18px",
                    "2xl": "20px",
                  }}
                  textAlign="center"
                  mt="10px"
                >
                  Create your own AI Clone with unlimited creativity. Generate
                  perfect AI images every time.{" "}
                </Text>
                <Flex mt="20px" align="center">
                  <Button
                    p="18px"
                    h="58px"
                    onClick={onOpen}
                    color="white"
                    bg="button.500"
                    _hover={{opacity:"0.9"}}
                  >
                    Start creating for free
                  </Button>
                  <a href="https://discord.gg/CMwtccKthy" target="_blank">
                    <Button
                      ml="5px"
                      borderRadius="12px"
                      p="18px"
                      h="58px"
                      maxW="180px"
                      leftIcon={<FaDiscord size="28px" />}
                      color="#5865F2"
                      variant="outline"
                      borderColor="#5865F2"
                      borderWidth="2px"
                    >
                      Join Discord
                    </Button>
                  </a>
                </Flex>
              </Flex>
            </Flex>
            <Image alt="AI generated gallery" mt="60px" src={gallery.src} />

          </Flex>
          <Flex
            color="white"
            px={["25px", "35px", "40px", "60px", "60px", "12%"]}
            py="26px"
            bg="black"
            justify="space-between"
          >
            <Text>✨ Every photo is unique!</Text>
            <Text>✨ Endless generations!</Text>
            <Text>✨ Endless Variations</Text>
            <Text>✨ Unimaginable scenes</Text>
          </Flex>
        </Flex>
      </Show>
    </>
  );
};

export default Header;
